import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { ChatWidget } from '../common/ChatWidget';
interface AppLayoutProps {
  children: React.ReactNode;
  onLogout: () => void;
  userRole: string | null;
}
export function AppLayout({
  children,
  onLogout,
  userRole
}: AppLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);
  return <div className="min-h-screen bg-slate-50" data-id="element-118">
      <Sidebar onLogout={onLogout} userRole={userRole} isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} data-id="element-119" />
      <TopBar userRole={userRole} onMenuToggle={() => setSidebarOpen(prev => !prev)} data-id="element-120" />
      <main className="ml-0 lg:ml-64 pt-16 min-h-screen" data-id="element-121">
        <div className="p-4 sm:p-6 max-w-7xl mx-auto" data-id="element-122">{children}</div>
      </main>
      <ChatWidget data-id="element-123" />
    </div>;
}